var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import uniqBy from 'lodash/uniqBy';
import React from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { withRouter, Redirect } from 'react-router-dom';
import { createStructuredSelector } from 'reselect';
import ZingTouch from 'zingtouch';
import { withTheme, withStyles } from '@material-ui/core/styles';
import { setBoostWords } from '../../../actions/boost';
import { createNewConversation } from '../../../actions';
import { setHostName, setRateConversationOpen } from '../../../actions/rate-conversation';
import { setSelectedTranscriptId, addNewTranscript } from '../../../actions/saved-transcript';
import { selectIsRateConversationOpen } from '../../../selectors/rate-conversation';
import { setLoadingApp } from '../../../actions/session';
import { selectEditedWords, selectLang, selectSpeakers, selectTranscripts, } from '../../../selectors/scribe-conversation';
import { selectBoostWords } from '../../../selectors/scribe-session';
import { SiteThemeContext } from '../../../contexts/SiteThemeProvider';
import CCPage from '../../cc-mode/CCPage';
import Loading from '../../../components/Loading';
import SnackbarWithCountdown from '../../../components/SnackbarWithCountdown';
import RateConversation from '../../../components/Rating/RateConversation';
import ConversationButtons from '../../../modules/conversation/ConversationButtons';
import SetupAudio from '../../../modules/scribe/SetupAudioContainer';
import ScribeKeypressHandlerContainer from '../../../modules/scribe/ScribeKeypressHandlerContainer';
import EditProfileModal from '../../../modules/scribe/EditProfileModal';
import ZoomBroadcastCaptionsPopupContainer from '../../../modules/scribe/ZoomBroadcastCaptionsPopupContainer';
import BoostModalContainer from '../../../modules/scribe/BoostModalContainer';
import KeyboardInput from '../../../modules/conversation/KeyboardInput';
import Landing from '../../../modules/landing/Landing';
import { calls, users } from '../../../services/api/ava';
import LocalStorage, { STORAGE_KEYS } from '../../../services/localStorage';
import { getSocket, getSocketIfExist } from '../../../utils/getSocket';
import * as segment from '../../../utils/segment';
import { getPlanType } from '../../../utils/status';
import { clearSearchValue } from '../../../utils/http';
import { sendConnectionRequestMessage, getDefaultRoomId, isConversationEnded, sendResetRoomIdMessage, sendRoomStateUpdateMessage, sendUsePaidAsrUpdateMessage, isDefaultRoomId, sendAccessBoostWords, } from '../../../utils/ws-v1';
import { log } from '../../../utils/log';
import { getOS } from '../../../utils';
import { setElectronCaptionMode } from '../../../utils/captionsMode';
import * as Conversation from '../../../utils/conversation';
import { getText } from '../../../utils/scribeUtils';
import { isBoostEnabled } from '../../../utils/status';
import ConversationView from '../ConversationView';
import styles from './ConversationPage.styles';
const branchSdk = require('branch-sdk');
class ScribeConversation extends React.Component {
    constructor(props) {
        super(props);
        this.onAvaName = (avaNameArg, meta) => __awaiter(this, void 0, void 0, function* () {
            const { user, history, setLoadingApp } = this.props;
            let avaName = avaNameArg;
            if (!avaName) {
                ({ avaNameRequested: avaName } = this.state);
            }
            const { askingUserName, requestedMeta } = this.state;
            if (!meta) {
                // eslint-disable-next-line
                meta = requestedMeta;
                this.setState({ requestedMeta: undefined });
            }
            if (user.userName === 'web guest' && !meta && askingUserName) {
                this.setState({ askingUserName: false });
                return;
            }
            if (user.avaName === avaName && avaName) {
                this.setState({ mirrorRequested: true });
                setTimeout(() => {
                    this.setState({ mirrorRequested: false });
                    history.push('/web/login');
                }, 5000);
                return;
            }
            setLoadingApp(true);
            this.setState({ connectionByUsernameRequested: true, askingUserName: false });
            const socket = getSocket();
            const fromSource = meta && meta.viaBranch ? 'qrcode' : 'default';
            const id = sendConnectionRequestMessage(socket, fromSource, { avaName }, meta);
            let gotConnectionResponse = false;
            const handleConnectResponse = (message) => {
                const data = JSON.parse(message.data);
                const stopListening = () => {
                    socket.removeEventListener('message', handleConnectResponse);
                };
                if (data.type === 'connection-response' && data.id === id) {
                    log('websocketMessage', 'info', {
                        message: data,
                        direction: 'b2m',
                    });
                    gotConnectionResponse = true;
                    this.handleConnectResponse(data, avaName, meta);
                }
                else if (data.type === 'room-status' && gotConnectionResponse) {
                    stopListening();
                    setLoadingApp(false);
                    // This user just joined a conversation
                    segment.track('Joined Conversation', {
                        HostAvaName: data.host.avaName,
                        HostUserId: data.host.avaId,
                        'Join Method': meta && meta.viaBranch ? 'Share Link' : 'Connect Request',
                    });
                    const metricsToUpdate = {
                        'Total Joins': 1,
                        'Total Invites Connected Count': meta && meta.viaBranch ? 1 : 0,
                    };
                    users.updateJoinMetrics({
                        avaId: user.avaId,
                        firebaseAuthUID: user.firebaseAuthUID || user.id,
                        joinMetrics: metricsToUpdate,
                    });
                }
            };
            socket.addEventListener('message', handleConnectResponse);
        });
        this.stopCallsIfNeeded = () => __awaiter(this, void 0, void 0, function* () {
            const { status, user } = this.props;
            Object.keys(status.twilioCalls || {}).forEach((sid) => {
                calls.terminateCall({ user, sid });
            });
        });
        // When a conversation ends, we enter a default room. This is probably to
        // maintain websocket connection.
        this.restartConversation = () => __awaiter(this, void 0, void 0, function* () {
            const { user, exitScribeMode, status, updateIsInConversation, setMicSelected, setAvailableMics } = this.props;
            const socket = getSocketIfExist();
            if (status.host && status.host.avaId === user.avaId) {
                this.stopCallsIfNeeded();
                if (socket)
                    sendRoomStateUpdateMessage(socket, { value: 'ended' });
            }
            clearSearchValue(window, 'token');
            exitScribeMode();
            if (socket)
                sendResetRoomIdMessage(socket, getDefaultRoomId(user.id));
            this.setState({
                connectionByUsernameRequested: false,
                hasConversationStarted: false,
                showBoostModal: false,
                showSaveTranscriptsModal: false,
            });
            updateIsInConversation(false);
            // When conversation ends, reset the mic selected and available mics.
            // They will get set again when user enters a new convo. They are needed
            // here because having this code in AudioRecorder will result in the
            // microphone staying off when switching between CC mode and expanded view.
            setMicSelected(null);
            setAvailableMics([]);
        });
        this.handleTranscriptInputVisibilityChange = () => {
            const { keyboardInputShown, updateKeyboardInputShown } = this.props;
            updateKeyboardInputShown(!keyboardInputShown);
        };
        this.handleOnEndConversationClick = () => {
            this.handleConversationEnd();
            this.setState({ endedByCurrentUser: true });
        };
        this.onNewTranscriptChange = (text) => {
            this.setState({ newTranscriptDraft: text });
        };
        this.getHostName = () => {
            const { status, speakers } = this.props;
            // When a conversation ends, the status may become empty. To keep the previous
            // conversation, the data needs to be passed in.
            if (!status || !speakers)
                return '';
            const hostId = status.id.split('_')[0];
            const host = speakers[hostId] || {};
            const hostName = host.userName || hostId;
            return hostName;
        };
        this.handleConversationEnd = () => __awaiter(this, void 0, void 0, function* () {
            const { broadcastToZoomToken, electronCaptionMode, haveTranscripts, scribeTrainingRequested, setHostName, setRateConversationOpen, setSelectedTranscriptId, status, } = this.props;
            const { broadcastToZoomWarningShown } = this.state;
            if (scribeTrainingRequested) {
                // Scribe Trainings are special conversations that don't need any special
                // treatment apart from just closing the conversation.
                this.restartConversation();
                return;
            }
            // Let's mark if that conversation was broadcasted
            this.setState({
                conversationBroadcastedToZoom: !!broadcastToZoomToken,
            });
            setHostName(this.getHostName());
            if (!window.electron && broadcastToZoomToken && !broadcastToZoomWarningShown) {
                this.setState({
                    broadcastToZoomWarningShown: true,
                    showZoomBroadcastingWarning: true,
                });
            }
            else {
                this.toggleConversationEndModal(true);
            }
            // Restart conversation because there is no handling of the save transcripts
            // popup in CC Mode.
            if (window.isElectron && electronCaptionMode) {
                if (haveTranscripts) {
                    setRateConversationOpen(true);
                    setSelectedTranscriptId(status.id);
                }
                yield this.restartConversation();
                this.toggleConversationEndModal(false);
            }
        });
        this.toggleConversationEndModal = (showEndModal = false) => {
            const { haveTranscripts, setCCMode, setRateConversationOpen, updateBroadcastToZoomToken, updateElectronCaptionMode, } = this.props;
            if (window.isElectron && showEndModal) {
                setCCMode(haveTranscripts ? 'rating' : 'home');
                if (haveTranscripts) {
                    setRateConversationOpen(true);
                }
            }
            updateBroadcastToZoomToken('');
            this.setState({
                roomEndingWarningBegin: 0,
                showConversationEndModal: showEndModal,
                showZoomBroadcastingWarning: false,
                broadcastToZoomWarningShown: false,
            });
            if (showEndModal && window.electronIPC && getOS() === 'Mac') {
                window.electronIPC.sendDeactivateMacInternalAudio();
            }
            // This logic is tricky. In order to know whether we should show the
            // boost/save transcript popup, we need to know when showConversationEndModal
            // is true. Boost popup takes priority over save transcripts.
            //
            // TODO: It would be nice to have a component that can manage all the popups
            // and then have a finished callback to know when everything is done.
            // This way, we are free to quickly and easily reorder pop ups.
            const boostEnabled = isBoostEnabled(this.props.subscription);
            const editedWords = this.checkEditedWords();
            if (showEndModal) {
                if (boostEnabled && editedWords) {
                    this.setState({ showBoostModal: true, editedWords });
                }
                else {
                    this.setState({ showSaveTranscriptsModal: true });
                }
            }
        };
        this.handleLoadUserBoostWords = (message) => {
            const data = JSON.parse(message.data);
            if (data.type === 'user-boost-words') {
                log('websocketMessage', 'info', { message: data, direction: 'b2f' });
                const { setBoostWords } = this.props;
                setBoostWords(data.words);
            }
        };
        this.updateTTSVoiceIfNeeded = (prevProps, prevState) => {
            const { speechLang: prevSpeechLang } = prevProps;
            const { speechLang } = this.props;
            const { ttsVoices: prevTTSVoices } = prevState;
            const { ttsVoices } = this.state;
            if (speechLang !== prevSpeechLang || ttsVoices !== prevTTSVoices) {
                this.findBestTTSVoice();
            }
        };
        this.closeRateConversationIfOpen = (prevProps) => {
            const { isInConversation: prevIsInConversation } = prevProps;
            const { electronCaptionMode, isInConversation, isRateConversationOpen, setRateConversationOpen } = this.props;
            if (isInConversation !== prevIsInConversation &&
                isRateConversationOpen &&
                !window.isElectron &&
                !electronCaptionMode) {
                setRateConversationOpen(false);
            }
        };
        this.updateElectronCaptionModeIfNeeded = (prevProps) => {
            const { electronCaptionMode: prevElectronCaptionMode } = prevProps;
            const { electronCaptionMode, updateKeyboardInputShown } = this.props;
            if (electronCaptionMode !== prevElectronCaptionMode) {
                this.handleElectronCaptionMode(electronCaptionMode);
                if (electronCaptionMode) {
                    updateKeyboardInputShown(false);
                }
            }
        };
        this.clearConversationAndSessionStateIfNeeded = (prevProps) => {
            const { socketConnectionStatus: prevSocketConnectionStatus } = prevProps;
            const { clearScribeConversationState, clearScribeSessionState, conversationStarted, history, socketConnectionStatus, } = this.props;
            if (!conversationStarted &&
                socketConnectionStatus === 'DISCONNECTED' &&
                prevSocketConnectionStatus === 'CONNECTED') {
                clearScribeConversationState();
                clearScribeSessionState();
                history.push('/web/login');
            }
        };
        this.startConversationIfNeeded = (prevProps) => {
            const { status: prevStatus } = prevProps;
            const { conversationEnded, status, updateConversationEndedStatus, user } = this.props;
            const { hasConversationStarted } = this.state;
            if ((status === null || status === void 0 ? void 0 : status.id) !== (prevStatus === null || prevStatus === void 0 ? void 0 : prevStatus.id) && !isConversationEnded(status, user) && !hasConversationStarted) {
                this.setState({ hasConversationStarted: true });
                if (conversationEnded) {
                    updateConversationEndedStatus(false);
                }
            }
        };
        this.endConvoDueToRestrictedSessionIfNeeded = (prevProps) => {
            var _a, _b, _c;
            const { status: prevStatus } = prevProps;
            const { electronCaptionMode, haveTranscripts, setCCMode, setRateConversationOpen, status, updateElectronCaptionMode, } = this.props;
            const { showConversationEndModal } = this.state;
            if (((_a = status === null || status === void 0 ? void 0 : status.state) === null || _a === void 0 ? void 0 : _a.value) !== ((_b = prevStatus === null || prevStatus === void 0 ? void 0 : prevStatus.state) === null || _b === void 0 ? void 0 : _b.value) &&
                ((_c = status.state) === null || _c === void 0 ? void 0 : _c.value) === 'ended' &&
                status.reason === 'room-ended-due-to-convo-restricted-session') {
                this.setState({ endedDueToConvoRestrictedSession: true });
                if (window.isElectron && electronCaptionMode) {
                    setCCMode(haveTranscripts ? 'rating' : 'home');
                    if (haveTranscripts) {
                        setRateConversationOpen(true);
                    }
                }
                if (!showConversationEndModal) {
                    this.restartConversation();
                }
            }
        };
        this.resetConversationStateIfNeeded = (prevProps) => {
            const { conversationEnded: prevConversationEnded } = prevProps;
            const { conversationEnded } = this.props;
            if (prevConversationEnded !== conversationEnded && conversationEnded) {
                this.setState({
                    endedDueToConvoRestrictedSession: false,
                    roomEndingWarningBegin: 0,
                    roomEndingWarningCountdown: 0,
                    roomEndingWarningProlongUrl: '',
                    appSubmittedTypeform: {},
                });
            }
        };
        this.setConvoRestrictedSessionWarningIfNeeded = (prevProps) => {
            var _a;
            const { status: prevStatus } = prevProps;
            const { status, subscription, user } = this.props;
            if (status.reason !== prevStatus.reason && status.reason === 'convo-restricted-session-warning') {
                const { i18n } = this.props;
                const params = {
                    lang: i18n.language,
                    src: 'timeout',
                    medium: window.isElectron ? 'desk' : 'web',
                    mkt: '',
                };
                switch (subscription.ongoingSubscription) {
                    case 'Campus':
                        params.mkt = 'edu';
                        break;
                    case 'Pro':
                        params.mkt = 'hr';
                        break;
                    case 'Premium':
                    case 'Free':
                        params.mkt = 'ind';
                        break;
                    default:
                        break;
                }
                let url = `https://ava-me.typeform.com/to/q2n11h${Object.keys(params).reduce((acc, curr) => `${acc}${curr}=${params[curr]}&`, '?')}`;
                url = url.substring(0, url.length - 1);
                url += `#userid=${LocalStorage.get(STORAGE_KEYS.AVA_ID) || ''}`;
                this.setState({
                    roomEndingWarningBegin: Date.now(),
                    roomEndingWarningCountdown: status.restrictions.convoWarningCountdownTimerMs / 1000 || 300,
                    roomEndingWarningProlongUrl: url,
                    appSubmittedTypeform: {
                        channel: 'inbound',
                        source: 'timeout',
                        market: params.mkt === 'ind' ? 'individual' : params.mkt,
                        organization_name: (_a = user.organization) === null || _a === void 0 ? void 0 : _a.name,
                        plan: getPlanType(subscription),
                    },
                });
            }
        };
        this.setConversationStartedIfNeeded = (prevProps) => {
            const { inTwilioCalls: prevInTwilioCalls, lastMutationReceived: prevLastMutationReceived, recording: prevRecording, status: prevStatus, } = prevProps;
            const { conversationEnded, currentPlatform, displayable, electronCaptionMode, haveTranscripts, inConferenceCall, inTwilioCalls, isInConversation, lastMutationReceived, lightView, muted, recording, setLoadingApp, setCCMode, setRateConversationOpen, scribe, scribeTrainingRequested, startRecord, status, stopRecord, subscription, toggleSideBar, updateConversationEndedStatus, updateElectronCaptionMode, updateIsInConversation, user, } = this.props;
            const { endedByCurrentUser } = this.state;
            // NOTE: The flow of data here is very hacky, and it only kinda works. It should
            // be refactored so that isInConversation is handled on the reducer level
            // rather than by one particular component. Basically there should be no state
            // manipulation on the component level at all, because it's sometimes very easy to
            // include infinite state update loops.
            // Identified problems:
            //  * `status` updates significantly after the user clicks the X button, which means that
            //    triggering updateIsInConversation by closing the conversation will be overriden shortly after.
            //  * comparing `status` with `prevStatus` in componentDidUpdate to see whether the conversation started
            //    or not means that it will not get triggered if the correct status is already present on mounting.
            //  * the only way to truly know whether a room has been closed is whether a host is still present
            //    as one of the participants. The state.value === 'ended' sometimes works, sometimes does not.
            const prevIsInConversationValue = (prevStatus === null || prevStatus === void 0 ? void 0 : prevStatus.id) && !isDefaultRoomId(prevStatus.id);
            const newIsInConversationValue = (status === null || status === void 0 ? void 0 : status.id) && !isDefaultRoomId(status.id);
            const isEnded = isConversationEnded(status, user);
            // endedByCurrentUser changes immediately, isEnded changes when the backend sends a status update.
            const convoJustStarted = !endedByCurrentUser && !isEnded && newIsInConversationValue && newIsInConversationValue !== isInConversation;
            const convoJustEnded = !newIsInConversationValue && newIsInConversationValue !== isInConversation;
            const convoFlippedToPublic = prevStatus.conversationMode === 'public-muted' && status.conversationMode === 'public';
            if ((prevStatus === null || prevStatus === void 0 ? void 0 : prevStatus.id) !== (status === null || status === void 0 ? void 0 : status.id)) {
                // Room changed, so we know the current user didn't close this one.
                this.setState({ endedByCurrentUser: false });
            }
            if (convoJustEnded) {
                // This happens when the server already sent us back to the default_room, but
                // the state still represents that we are in conversation.
                updateIsInConversation(false);
            }
            if (convoJustStarted) {
                const screenWidth = Math.max((document.documentElement && document.documentElement.clientWidth) || 0, window.innerWidth || 0);
                if (screenWidth > 768 && !window.isElectron && !electronCaptionMode) {
                    toggleSideBar(true);
                }
                const socket = getSocket();
                sendRoomStateUpdateMessage(socket, { value: 'ongoing' });
                sendUsePaidAsrUpdateMessage(socket, true);
                updateIsInConversation(true);
                setLoadingApp(false);
                if (window.isElectron) {
                    updateElectronCaptionMode(true);
                    setCCMode('conversation');
                }
            }
            if ((convoJustStarted || convoFlippedToPublic) &&
                currentPlatform === 'web' &&
                displayable.audio &&
                newIsInConversationValue &&
                !inConferenceCall &&
                !muted &&
                !lightView &&
                (!scribe || scribeTrainingRequested) &&
                !inTwilioCalls) {
                startRecord();
            }
            if (prevRecording && inTwilioCalls && !prevInTwilioCalls) {
                stopRecord();
            }
            // WARNING: Muting timer logic is tricky and error-prone, so be careful.
            // If we are not recording anymore - stop the muting timer, so that it does
            // not spill over into the next potential recording session.
            if (!recording && prevRecording) {
                this.stopMutingTimer();
            }
            // For some reason backend's participants list contains duplicates.
            const countParticipants = (participants) => uniqBy(participants || [], 'avaId').length;
            // If there is more than one user - never mute the mic.
            if (countParticipants(status.participants) > 1) {
                this.stopMutingTimer();
            }
            // Restart the muting timer if there is a transcript mutation.
            if ((!subscription ||
                subscription.ongoingSubscription === 'Free' ||
                subscription.ongoingSubscriptionSubtype === 'Lite') &&
                lastMutationReceived !== prevLastMutationReceived) {
                this.startMutingTimer(stopRecord, true);
            }
            if (status && status.participants) {
                const isFakeRoom = isDefaultRoomId(status.id);
                const isHost = status.host.avaId === user.avaId;
                const numOfParticipants = countParticipants(status.participants);
                if (!isFakeRoom && !isHost && this.previousNumOfParticipants > 1 && numOfParticipants === 1) {
                    this.handleConversationEnd();
                }
                this.previousNumOfParticipants = numOfParticipants;
            }
            if (
            // The recording is beginning.
            !prevRecording &&
                recording &&
                !inTwilioCalls &&
                !inConferenceCall &&
                // Sometimes the status.participants list will be empty when we start
                // recording. But if there is more than one participant - the timer
                // will be reset after the list updates.
                countParticipants(status.participants) <= 1 &&
                (subscription.ongoingSubscription === 'Free' || subscription.ongoingSubscriptionSubtype === 'Lite')) {
                // If we are starting to record, but it's not a twilio call and there is
                // only one user -> silence the mic after 100 seconds.
                this.startMutingTimer(stopRecord);
            }
            if (isInConversation && isConversationEnded(status, user) && !conversationEnded) {
                updateConversationEndedStatus(true);
                if (window.isElectron && electronCaptionMode) {
                    setCCMode(haveTranscripts ? 'rating' : 'home');
                    if (haveTranscripts) {
                        setRateConversationOpen(true);
                    }
                }
            }
        };
        this.displayZoomExportPopupIfNeeded = (prevProps) => {
            const { inTwilioCalls: prevInTwilioCalls } = prevProps;
            const { status } = this.props;
            const { zoomExportPopup } = this.state;
            if (prevInTwilioCalls &&
                Object.values(status.twilioCalls).find((call) => call.conferenceType === 'zoom') &&
                zoomExportPopup !== status.id &&
                zoomExportPopup !== 'display') {
                this.setState({ zoomExportPopup: 'display' });
            }
        };
        this.checkEditedWords = () => {
            const { editedWords, transcripts, boostWords, lang } = this.props;
            const boostWordsLowercase = boostWords.map((w) => w.toLowerCase());
            const stripPunctuation = (value) => {
                return value ? value.replace(/[_.,!?]/g, '').trim() : '';
            };
            const words = editedWords
                .map((word) => (Object.assign(Object.assign({}, word), { text: stripPunctuation(word.text) })))
                .filter((w) => !!w.text &&
                transcripts[w.transcriptionId] &&
                getText(transcripts[w.transcriptionId], lang).includes(w.text) &&
                !boostWordsLowercase.includes(w.text.toLowerCase()))
                .map((w) => w.text);
            return words.length ? uniqBy(words, (w) => w.toLowerCase()) : null;
        };
        // Callback when save transcript popup finishes.
        // Since this is the last popup, it will handle leaving the conversation.
        this.handleSaveTranscriptPopup = ({ saveClicked }) => {
            this.setState({ transcriptSaveClicked: saveClicked, showSaveTranscriptsModal: false });
            this.handleLeaveConversation();
        };
        this.handleHideZoomBroadcastWarning = () => {
            this.setState({ showZoomBroadcastingWarning: false });
        };
        // Callback when boost modal finishes.
        this.handleBoostPopup = () => {
            this.setState({
                showBoostModal: false,
                editedWords: [],
                showSaveTranscriptsModal: true,
            });
        };
        this.handleLeaveConversation = () => __awaiter(this, void 0, void 0, function* () {
            var _a, _b;
            const { allMicsSelected, electronCaptionMode, getTranscriptStats, fetchAvaProfileMetrics, inTwilioCalls, user, status, setConversationStatus, setRateConversationOpen, // eslint-disable-line no-shadow
            setSelectedTranscriptId, // eslint-disable-line no-shadow
            addNewTranscript, // eslint-disable-line no-shadow
            speakers, transcripts, history, } = this.props;
            const { conversationBroadcastedToZoom, endedByCurrentUser, endedDueToConvoRestrictedSession } = this.state;
            this.setState({ redirectLoading: true });
            yield this.restartConversation();
            const timestamp = Date.now();
            const isSaveTranscript = !!((_a = user === null || user === void 0 ? void 0 : user.features) === null || _a === void 0 ? void 0 : _a.saveTranscript);
            const isForbidConversationSaving = !!((_b = user === null || user === void 0 ? void 0 : user.features) === null || _b === void 0 ? void 0 : _b['forbid-conversation-saving']);
            const shouldRedirectToTranscriptsPage = (this.state.transcriptSaveClicked || (isSaveTranscript && !isForbidConversationSaving)) &&
                !window.isElectron &&
                !electronCaptionMode;
            const transcriptStats = getTranscriptStats();
            setConversationStatus(status);
            Conversation.trackHadConversation({
                allMicsSelected,
                conversationStatus: status,
                conversationBroadcastedToZoom,
                endedByCurrentUser,
                endedDueToConvoRestrictedSession,
                fetchAvaProfileMetrics,
                inTwilioCalls,
                isTranscriptSaved: isSaveTranscript && !isForbidConversationSaving,
                transcriptStats,
                user,
            });
            const leaveConversation = () => {
                const { haveTranscripts } = this.props;
                if (haveTranscripts) {
                    setRateConversationOpen(true);
                }
                this.setState({
                    shouldRedirectToTranscripts: shouldRedirectToTranscriptsPage,
                    redirectLoading: false,
                });
                this.toggleConversationEndModal(false);
            };
            leaveConversation();
            if (shouldRedirectToTranscriptsPage) {
                setSelectedTranscriptId(status.id);
                if (Object.keys(transcripts).length) {
                    const blocs = Conversation.getBlocs({ speakers, transcripts });
                    const isAllowedAccess = Conversation.getIsAllowedAccess({ status, user });
                    const convoSpeakers = Conversation.getSpeakers({ speakers });
                    const convoTranscripts = Conversation.getBlocs({ speakers, transcripts }).length > 0;
                    const newTranscript = {
                        blocs,
                        conversationMode: status.conversationMode,
                        endTimestampMs: timestamp,
                        env: 'production',
                        hasTranscripts: Object.keys(transcripts).length > 0,
                        isAllowedAccess,
                        langs: status.langs,
                        links: status.links,
                        roomId: status.id,
                        speakers: convoSpeakers,
                        startTimestampMs: status.startTimestampMs,
                        t0: status.startTimestampMs,
                        t1: timestamp,
                        title: status.title,
                        custom_title: status.title,
                        transcripts: convoTranscripts,
                    };
                    addNewTranscript(newTranscript);
                    history.push('/web/conversations');
                }
            }
        });
        this.state = {
            hasConversationStarted: false,
            connectionByUsernameRequested: false,
            askingUserName: false,
            newTranscriptDraft: '',
            requestedMeta: undefined,
            previousDarkMode: false,
            showConversationEndModal: false,
            showZoomBroadcastingWarning: false,
            broadcastToZoomWarningShown: false,
            themeHasSwitched: true,
            roomEndingWarningBegin: 0,
            roomEndingWarningCountdown: 0,
            roomEndingWarningProlongUrl: '',
            checkIfDesktopAppInstalled: false,
            showDesktopAppCaptionPopup: false,
            conversationBroadcastedToZoom: false,
            ttsVoices: [],
            ttsBestVoice: undefined,
            endedByCurrentUser: false,
            endedDueToConvoRestrictedSession: false,
            shouldRedirectToTranscripts: false,
            redirectLoading: false,
            conversationContainerHovered: false,
            showBoostModal: false,
            editedWords: [],
            showSaveTranscriptsModal: false,
            appSubmittedTypeform: {},
            mirrorRequested: false,
        };
        this.onConversationEnd = () => {
            this.handleConversationEnd();
        };
        this.handleLoadUserBoostWords = this.handleLoadUserBoostWords.bind(this);
    }
    handleEditProfilModalClose({ updated }) {
        this.setState({
            askingUserName: !updated,
        });
    }
    handleConnectResponse(data, avaName, meta) {
        const { t } = this.props;
        if (data.value) {
            if (data.conversationMode === 'private') {
                this.setState({
                    askingUserName: true,
                    requestedMeta: meta,
                    avaNameRequested: avaName,
                });
            }
            return;
        }
    }
    findBestTTSVoice() {
        const { ttsVoices } = this.state;
        const { speechLang } = this.props;
        let voice;
        if (window.speechSynthesis && ttsVoices.length) {
            let candidateVoices = ttsVoices.filter((v) => v.lang === speechLang);
            if (!candidateVoices.length) {
                const pattern = /-|_/;
                const shortLang = speechLang.split(pattern)[0];
                candidateVoices = ttsVoices.filter((v) => v.lang.split(pattern)[0] === shortLang);
            }
            if (candidateVoices.length === 1)
                [voice] = candidateVoices;
            if (candidateVoices.length > 1) {
                // TODO: Select the best candidate based on user's gender.
                // "Male", "Female", "David", "Zira" are good indicators for gender
                // of the voice for English voices.
                [voice] = candidateVoices;
            }
        }
        this.setState({ ttsBestVoice: voice });
    }
    handleElectronCaptionMode(on) {
        const { theme } = this.props;
        const { showConversationEndModal } = this.state;
        setElectronCaptionMode(on, showConversationEndModal);
        if (on) {
            this.setState({
                previousDarkMode: theme.palette.type === 'dark',
                themeHasSwitched: false,
            });
        }
    }
    componentDidMount() {
        const { branch, token, scribe, toggleSideBar, subscription } = this.props;
        // This IS critical for join-by-link
        const request = localStorage.getItem('ava_request');
        if (request) {
            const viaBranch = localStorage.getItem('via_branch') === request;
            localStorage.removeItem('ava_request');
            localStorage.removeItem('via_branch');
            this.onAvaName(`${request}`, { viaBranch });
        }
        else if (branch && (branch.convoChannel || branch.roomId)) {
            this.onAvaName(`${branch.hostAvaId}`, {
                roomId: branch.convoChannel || branch.roomId,
                viaBranch: true,
            });
        }
        else if (token) {
            this.onAvaName(``, { token, scribe: !!scribe });
        }
        const containerElement = window.document.getElementById('gesture');
        const activeRegion = ZingTouch.Region(containerElement, false, false);
        activeRegion.bind(containerElement, 'swipe', (event) => {
            const { currentDirection } = event.detail.data[0];
            if (currentDirection < 20 || currentDirection > 340) {
                toggleSideBar(true);
            }
            else if (currentDirection > 160 && currentDirection < 200) {
                toggleSideBar(false);
            }
        });
        if (window.speechSynthesis) {
            const that = this;
            const populateVoiceList = () => {
                const newVoices = window.speechSynthesis.getVoices();
                if (newVoices || newVoices.length) {
                    that.setState({ ttsVoices: newVoices });
                }
            };
            // FF, Chrome and Safari have the voice list prepared at different
            // moments and implement different parts of the API. MDN shows this way
            // of updating the voice list as working for all the browsers in 03/2021.
            populateVoiceList();
            if (window.speechSynthesis.onvoiceschanged !== undefined) {
                window.speechSynthesis.onvoiceschanged = populateVoiceList;
            }
        }
        if (window.electronIPC) {
            window.electronIPC.onEndConversation(this.onConversationEnd);
        }
        const ws = getSocketIfExist();
        if (ws && isBoostEnabled(subscription)) {
            ws.addEventListener('message', this.handleLoadUserBoostWords);
            sendAccessBoostWords(ws, 'list');
        }
    }
    componentDidUpdate(prevProps, prevState) {
        this.updateTTSVoiceIfNeeded(prevProps, prevState);
        this.closeRateConversationIfOpen(prevProps);
        this.updateElectronCaptionModeIfNeeded(prevProps);
        this.clearConversationAndSessionStateIfNeeded(prevProps);
        this.startConversationIfNeeded(prevProps);
        this.endConvoDueToRestrictedSessionIfNeeded(prevProps);
        this.resetConversationStateIfNeeded(prevProps);
        this.setConvoRestrictedSessionWarningIfNeeded(prevProps);
        this.setConversationStartedIfNeeded(prevProps);
        this.displayZoomExportPopupIfNeeded(prevProps);
        const { isInConversation } = this.props;
        if (isInConversation) {
            // Hide the journey banner
            branchSdk.closeJourney();
        }
        else {
            // Show the journey banner
            branchSdk.track('pageview');
        }
    }
    componentWillUnmount() {
        const { subscription, updateIsInConversation } = this.props;
        const ws = getSocketIfExist();
        if (ws && isBoostEnabled(subscription)) {
            ws.removeEventListener('message', this.handleLoadUserBoostWords);
        }
        updateIsInConversation(false);
    }
    // Returns true is the timer was previously started.
    stopMutingTimer() {
        const timeoutSet = this.silenceTimeout !== undefined;
        if (timeoutSet) {
            clearTimeout(this.silenceTimeout);
            this.silenceTimeout = undefined;
        }
        return timeoutSet;
    }
    // If onlyRestart is set to true, will only start the timer if it was already
    // running. If onlyRestart is unset it will always start the timer anew.
    startMutingTimer(stopRecord, onlyRestart) {
        const timeoutSet = this.stopMutingTimer();
        if (onlyRestart && !timeoutSet)
            return;
        this.silenceTimeout = setTimeout(() => {
            stopRecord();
        }, 100 * 1000);
    }
    getEditRight() {
        const { intercomDisplayed } = this.props;
        return intercomDisplayed ? 170 : 90;
    }
    render() {
        const { classes, currentPlatform, createNewConversation, electronCaptionMode, fullScreen, inConferenceCall, inTwilioCalls, isBoosting, isInConversation, lightView, loading, microphoneAccess, muted, needInternalAudioAccess, keyboardInputShown, scribe, showQuickSetup, socketConnectionStatus, status: newStatus, t, theme, user, isRateConversationOpen, } = this.props;
        const status = newStatus;
        const { connectionByUsernameRequested, askingUserName, newTranscriptDraft, avaNameRequested, zoomExportPopup, previousDarkMode, roomEndingWarningBegin, roomEndingWarningCountdown, roomEndingWarningProlongUrl, themeHasSwitched, conversationBroadcastedToZoom, ttsBestVoice, endedByCurrentUser, shouldRedirectToTranscripts, redirectLoading, conversationContainerHovered, showBoostModal, showSaveTranscriptsModal, editedWords, appSubmittedTypeform, mirrorRequested, } = this.state;
        if (mirrorRequested) {
            return React.createElement("h2", null, "You cannot join your own conversation");
        }
        if (window.isElectron && electronCaptionMode) {
            return (React.createElement(React.Fragment, null,
                React.createElement(SiteThemeContext.Consumer, null, ({ handleThemeChange, theme: currentTheme }) => {
                    if (currentTheme === 'light' && isInConversation && window.isElectron && electronCaptionMode) {
                        handleThemeChange();
                    }
                    else if (currentTheme === 'dark' &&
                        isInConversation &&
                        window.isElectron &&
                        !electronCaptionMode &&
                        !previousDarkMode &&
                        !themeHasSwitched) {
                        handleThemeChange();
                        this.setState({
                            themeHasSwitched: true,
                        });
                    }
                }),
                React.createElement(CCPage, { onEndConversation: this.handleOnEndConversationClick, roomEndingWarningCountdown: roomEndingWarningCountdown, roomEndingWarningBegin: roomEndingWarningBegin, roomEndingWarningProlongUrl: roomEndingWarningProlongUrl, appSubmittedTypeform: appSubmittedTypeform })));
        }
        if (loading) {
            return React.createElement(Loading, { text: t('joiningConversation') });
        }
        if (redirectLoading) {
            return React.createElement(Loading, null);
        }
        if (needInternalAudioAccess || microphoneAccess !== 'granted' || showQuickSetup) {
            return React.createElement(SetupAudio, { t: t, microphoneAccess: microphoneAccess, needInternalAudioAccess: needInternalAudioAccess });
        }
        if (shouldRedirectToTranscripts) {
            return (React.createElement(Redirect, { to: {
                    pathname: '/web/conversations',
                    state: {
                        conversationBroadcastedToZoom,
                        endedByCurrentUser,
                    },
                } }));
        }
        return (React.createElement("div", { style: { height: '100%' } },
            React.createElement(SiteThemeContext.Consumer, null, ({ handleThemeChange, theme: currentTheme }) => {
                if (currentTheme === 'light' && isInConversation && window.isElectron && electronCaptionMode) {
                    handleThemeChange();
                }
                else if (currentTheme === 'dark' &&
                    isInConversation &&
                    window.isElectron &&
                    !electronCaptionMode &&
                    !previousDarkMode &&
                    !themeHasSwitched) {
                    handleThemeChange();
                    this.setState({
                        themeHasSwitched: true,
                    });
                }
            }),
            React.createElement("audio", { id: "player", controls: true, muted: true, style: { display: 'none' } }),
            !window.isElectron && zoomExportPopup === 'display' && (React.createElement(ZoomBroadcastCaptionsPopupContainer, { on: zoomExportPopup === 'display', setOff: () => {
                    this.setState({ zoomExportPopup: status.id });
                } })),
            React.createElement("div", { className: `conversation-container ${classes.container}`, onMouseEnter: () => this.setState({ conversationContainerHovered: true }), onMouseLeave: () => this.setState({ conversationContainerHovered: false }), style: {
                    overflowX: 'hidden',
                    position: 'relative',
                    // If we are in caption mode, we want Electron to manage the
                    // background, since we want it to be transparent.
                    backgroundColor: window.isElectron && electronCaptionMode ? 'inherit' : theme.palette.background.default,
                    background: window.isElectron && electronCaptionMode ? theme.palette.ccMode.backgroundGradient : null,
                    height: window.isElectron && electronCaptionMode ? `100vh` : `100%`,
                    fontFamily: theme.typography.fontFamily,
                    width: '100%',
                } },
                askingUserName && (React.createElement(EditProfileModal, { open: askingUserName, close: (e) => this.handleEditProfilModalClose(e), title: t('profilModal.enterYourName'), subtitle: `${t('profilModal.weNeedToAnnouceYouTo')} &${avaNameRequested || ''}`, defaultUserName: "", action: t(`profilModal.continue`) })),
                React.createElement(BoostModalContainer, { open: isBoosting, boostList: (status === null || status === void 0 ? void 0 : status.boost) || [] }),
                currentPlatform === 'web' &&
                    !muted &&
                    !lightView &&
                    !scribe &&
                    !fullScreen &&
                    !inConferenceCall &&
                    !inTwilioCalls &&
                    isInConversation && (React.createElement(React.Fragment, null,
                    React.createElement(KeyboardInput, { value: newTranscriptDraft, onChange: this.onNewTranscriptChange, keyboardInputShown: keyboardInputShown, ttsBestVoice: ttsBestVoice }))),
                React.createElement("span", null, socketConnectionStatus === 'CONNECTED' && !muted && !lightView && (
                // eslint-disable-next-line
                React.createElement(ScribeKeypressHandlerContainer, { rights: currentPlatform }))),
                React.createElement(SnackbarWithCountdown, { message: t('snackbar.convoRestrictedSessionWarning'), countdown: roomEndingWarningCountdown, countdownBegin: roomEndingWarningBegin, additionalActionMessage: t('snackbar.convoRestrictedSessionProlong'), additionalActionUrl: roomEndingWarningProlongUrl, appSubmittedTypeform: appSubmittedTypeform }),
                !loading && !isInConversation && !connectionByUsernameRequested && (React.createElement(Landing, { host: user && user.features && user.features['web-host'], onHost: createNewConversation, twilio: user && user.features && user.features.twilio })),
                (!status.participants || isInConversation) && (React.createElement(ConversationView, { conversationContainerHovered: conversationContainerHovered, editedWords: editedWords, handleBoostPopup: this.handleBoostPopup, handleSaveTranscriptPopup: this.handleSaveTranscriptPopup, hideZoomBroadcastingWarning: this.handleHideZoomBroadcastWarning, showBoostModal: showBoostModal, showSaveTranscriptsModal: showSaveTranscriptsModal, toggleConversationEndModal: this.toggleConversationEndModal })),
                React.createElement(ConversationButtons, { onKeyboardButtonClick: this.handleTranscriptInputVisibilityChange, onEndConversationClick: this.handleOnEndConversationClick })),
            !isInConversation && isRateConversationOpen && (React.createElement(RateConversation, { conversationBroadcastedToZoom: conversationBroadcastedToZoom, endedByCurrentUser: endedByCurrentUser }))));
    }
}
const mapStateToProps = createStructuredSelector({
    isRateConversationOpen: selectIsRateConversationOpen,
    speakers: selectSpeakers,
    transcripts: selectTranscripts,
    editedWords: selectEditedWords,
    boostWords: selectBoostWords,
    lang: selectLang,
});
const mapDispatchToProps = {
    setRateConversationOpen,
    setSelectedTranscriptId,
    createNewConversation,
    addNewTranscript,
    setHostName,
    setBoostWords,
    setLoadingApp,
};
export default withTranslation()(withRouter(withTheme(withStyles(styles)(connect(mapStateToProps, mapDispatchToProps)(ScribeConversation)))));
